import styled from "@emotion/styled";
import { FC, MouseEventHandler } from "react";

import { ChevronLeft } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, RadiusToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { IWithTestSelector } from "components/interfaces";
import { replaceWithSubstring } from "helpers/string";
import { withVar } from "themes/helpers";

interface IProps extends IWithTestSelector {
  name: string;
  onArrowClick: MouseEventHandler<HTMLButtonElement> & MouseEventHandler<HTMLAnchorElement>;
}

export const CannedResponseItem: FC<IProps> = ({ testSelector, name, onArrowClick }) => {
  const nameWithPlaceholders = replaceWithSubstring(name, "[cid", "]", "[Image]");

  return (
    <Container data-testid={testSelector}>
      <Button
        kind="plain"
        size="xcompact"
        onClick={onArrowClick}
        data-testid="back-shortcuts-button"
        icon={<Icon source={ChevronLeft} customColor={withVar(DesignToken.ContentBasicSecondary)} />}
      />
      <CannedResponseText data-testid="canned-response-text">{nameWithPlaceholders}</CannedResponseText>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: 360px;
  min-width: 90px;
  gap: var(${SpacingToken.Spacing2});
  padding: 6px;
  cursor: pointer;
  border-radius: ${withVar(RadiusToken.Radius3)};

  &:hover,
  &.focused {
    background-color: ${withVar(DesignToken.SurfacePrimaryHover)};
  }
`;

const CannedResponseText = styled(Text)`
  max-width: 300px;
  white-space: pre-wrap;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
